export default {"src":"/_next/static/media/check.4ceeb68b.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};